<div class="wrap" #wrapComponent>
  <div class="content">
    <div class="header">{{ "@pages.welcome.header" | translate }}</div>
    <div class="guide-block">
      <img
        src="./../../../../assets/illustrations/welcome-page/scan.svg"
        alt=""
        class="illustration"
      />
      <div class="guide-header">
        1. {{ "@pages.welcome.guide.0" | translate }}
      </div>
    </div>

    <div class="guide-block">
      <img
        src="./../../../../assets/illustrations/welcome-page/product.svg"
        alt=""
        class="illustration"
      />
      <div class="guide-header">
        2. {{ "@pages.welcome.guide.1" | translate }}
      </div>
    </div>

    <div class="guide-block">
      <img
        src="./../../../../assets/illustrations/welcome-page/pay.svg"
        alt=""
        class="illustration"
      />
      <div class="guide-header">
        3. {{ "@pages.welcome.guide.2" | translate }}
      </div>
    </div>
  </div>

  <app-action-button
    [label]="'@pages.welcome.cta' | translate"
    (click)="onContinue()"
  ></app-action-button>

  <app-scroll-float-hint
    *ngIf="shouldShowScrollFloatHint"
    appScrollHint
    [appScrollHintContainerComponent]="wrapComponent"
    class="scroll-float-hint"
    (click)="scrollPageToBottom(wrapComponent)"
  ></app-scroll-float-hint>
</div>
